import React from 'react';

export default class PawnErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Pawn app error:', error, info);
  }

  handleReload = () => {
    window.location.href = '/pawn-app?reload=1';
  };

  handleClearAndReload = async () => {
    try {
      if ('serviceWorker' in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
      if ('caches' in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
    } catch (e) {
      console.warn(e);
    }
    window.location.href = '/pawn-app?reload=1';
  };

  render() {
    if (this.state.error) {
      return (
        <div className="pawn-app-shell d-flex align-items-center justify-content-center p-4">
          <div className="text-center" style={{ maxWidth: 360 }}>
            <i className="bi bi-exclamation-triangle text-warning display-4" />
            <h1 className="h5 mt-3">Pawn app could not start</h1>
            <p className="small text-muted">{String(this.state.error?.message || this.state.error)}</p>
            <button type="button" className="btn btn-warning w-100 mb-2" onClick={this.handleReload}>
              Reload
            </button>
            <button type="button" className="btn btn-outline-secondary w-100" onClick={this.handleClearAndReload}>
              Clear cache &amp; reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
